import { replaceBindings } from "./replaceBindings.js";
export function parseFunction(fn, state, app, options) {
  var transformedSource = replaceBindings(fn, state, app, options, true);
  if (!transformedSource) {
    return null;
  }
  return {
    name: fn.node.id.name,
    source: transformedSource,
    typescript: true
  };
}
//# sourceMappingURL=parseFunction.js.map